import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'proposals',
    description: 'Explore and craft proposals across Attain.',
    icon: 'compass',
    name: 'Proposals',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
